module.exports = "<app-slider></app-slider>\n\n<app-menu></app-menu>\n\n<div class=\"container-fluid\">\n  <div class=\"page\">\n    <br /><br />\n    <router-outlet></router-outlet>\n  </div>\n  <div class=\"feed\">\n    <br /><br />\n    <app-feed-block></app-feed-block>\n  </div>\n</div>\n\n<app-copyright></app-copyright>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/AnnaNorbisrath/WebstormProjects/me.rainer.surfschule-wiesensee/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main